import { useDevOpsLDClient } from "../contexts/DevOpsLDContext";

const FLAG_KEY = "system-outage-banner";
const DEFAULT_VALUE = { enabled: false, message: "", type: "info" };

export function useSystemOutageFlag() {
  const client = useDevOpsLDClient();
  if (!client) return false;

  const value = client.variation(FLAG_KEY, DEFAULT_VALUE);
  return value?.enabled === true;
}
